import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Alert, AlertDescription } from '../ui/Alert';
import { Badge } from '../ui/Badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/Tabs';
import { toast } from '../../utils/toast';
import { apiService } from '../../services/apiService';
// Icon components as inline SVGs
const UploadIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
  </svg>
);

const TestTubeIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);



const Trash2Icon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const EditIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);

const RefreshCwIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </svg>
);

const AlertCircleIcon = ({ className = "w-4 h-4" }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);



const EyeIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

const EyeOffIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
  </svg>
);

interface SessionData {
  cookies: Array<{
    name: string;
    value: string;
    domain: string;
    path: string;
    secure: boolean;
    httpOnly: boolean;
    sameSite: string;
  }>;
  origins: Array<{
    origin: string;
    localStorage: Record<string, string>;
    sessionStorage: Record<string, string>;
  }>;
}

interface PlatformSession {
  id: number;
  platform: string;
  platform_display_name: string;
  expires_at: string;
  created_at: string;
  last_used: string;
  is_active: boolean;
  is_expired: boolean;
}

interface SessionStatus {
  [key: string]: {
    platform_name: string;
    display_name: string;
    has_session: boolean;
    expires_at: string | null;
    last_used: string | null;
    is_expired: boolean;
    cost: number;
  };
}

const SessionManager: React.FC = () => {
  const [activeTab, setActiveTab] = useState('upload');
  const [sessions, setSessions] = useState<PlatformSession[]>([]);
  const [sessionStatus, setSessionStatus] = useState<SessionStatus>({});
  const [loading, setLoading] = useState(false);
  const [testResults, setTestResults] = useState<Record<string, any>>({});

  // Upload form state
  const [selectedPlatform, setSelectedPlatform] = useState('facebook');
  const [sessionDataText, setSessionDataText] = useState('');
  const [expiresHours, setExpiresHours] = useState(24);
  const [showSessionData, setShowSessionData] = useState(false);
  const [manualCookies, setManualCookies] = useState({
    xs: '',
    fr: '',
    datr: '',
    sb: '',
    fb_dtsg: '',
    lsd: ''
  });
  const [isEditMode, setIsEditMode] = useState(false);

  // Test form state
  const [testEmail, setTestEmail] = useState('');
  const [testPlatform, setTestPlatform] = useState('facebook');
  const [testLoading, setTestLoading] = useState(false);

  const platforms = [
    { value: 'facebook', label: 'Facebook', color: 'bg-blue-100 dark:bg-blue-900/30' },
    { value: 'instagram', label: 'Instagram', color: 'bg-pink-500' },
    { value: 'linkedin', label: 'LinkedIn', color: 'bg-blue-600' },
    { value: 'x', label: 'X (Twitter)', color: 'bg-black' },
    { value: 'snapchat', label: 'Snapchat', color: 'bg-yellow-400' },
    { value: 'github', label: 'GitHub', color: 'bg-gray-800' },
  ];

  // Facebook browser extraction script
  const facebookExtractionScript = `// Facebook Session Data Extractor
// Run this script in your browser's console while logged into Facebook

(function() {
  console.log('🔍 Extracting Facebook session data...');
  
  // Extract cookies
  const cookies = document.cookie.split(';').map(cookie => {
    const [name, value] = cookie.trim().split('=');
    return {
      name: name,
      value: value || '',
      domain: '.facebook.com',
      path: '/',
      secure: location.protocol === 'https:',
      httpOnly: false,
      sameSite: 'None'
    };
  }).filter(cookie => cookie.name && cookie.value);
  
  // Extract localStorage
  const localStorage = {};
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);
    if (key) {
      localStorage[key] = window.localStorage.getItem(key);
    }
  }
  
  // Extract sessionStorage
  const sessionStorage = {};
  for (let i = 0; i < window.sessionStorage.length; i++) {
    const key = window.sessionStorage.key(i);
    if (key) {
      sessionStorage[key] = window.sessionStorage.getItem(key);
    }
  }
  
  // Create session data object
  const sessionData = {
    cookies: cookies,
    origins: [{
      origin: window.location.origin,
      localStorage: localStorage,
      sessionStorage: sessionStorage
    }]
  };
  
  // Display the result
  console.log('✅ Facebook session data extracted successfully!');
  console.log('📋 Copy the JSON data below:');
  console.log(JSON.stringify(sessionData, null, 2));
  
  // Check for important cookies
  const importantCookies = ['c_user', 'xs', 'fr', 'datr', 'sb', 'dpr', 'locale', 'presence', 'wd'];
  const missingCookies = importantCookies.filter(cookieName => 
    !cookies.some(cookie => cookie.name === cookieName)
  );
  
  if (missingCookies.length > 0) {
    console.log('⚠️ Missing important cookies:', missingCookies);
    console.log('💡 These cookies are httpOnly and need manual extraction:');
    console.log('1. Open Developer Tools (F12)');
    console.log('2. Go to Application/Storage tab');
    console.log('3. Click on Cookies > https://www.facebook.com');
    console.log('4. Manually copy the missing cookies and add them to the session data');
    console.log('5. Use the "Manual Cookie Input" section in the session manager');
  }
  
  // Copy to clipboard if possible
  if (navigator.clipboard) {
    navigator.clipboard.writeText(JSON.stringify(sessionData, null, 2))
      .then(() => console.log('📋 Session data copied to clipboard!'))
      .catch(() => console.log('⚠️ Could not copy to clipboard automatically'));
  }
  
  return sessionData;
})();`;

  // Get platform-specific instructions
  const getPlatformInstructions = (platform: string) => {
    switch (platform) {
      case 'facebook':
        return {
          title: 'Facebook Session Setup',
          steps: [
            '1. Open Facebook in your browser and log in',
            '2. Open browser developer tools (F12)',
            '3. Go to the Console tab',
            '4. Copy and paste the script below into the console',
            '5. Press Enter to run the script',
            '6. Copy the JSON output that appears',
            '7. Paste it in the Session Data field below'
          ],
          script: facebookExtractionScript,
          note: 'Make sure you are logged into Facebook before running the script.'
        };
      case 'instagram':
        return {
          title: 'Instagram Session Setup',
          steps: [
            '1. Open Instagram in your browser and log in',
            '2. Open browser developer tools (F12)',
            '3. Go to the Application/Storage tab',
            '4. Copy cookies and localStorage data',
            '5. Format as JSON and paste below'
          ],
          script: '// Instagram extraction script would go here',
          note: 'Instagram session extraction requires manual cookie copying.'
        };
      default:
        return {
          title: `${platform.charAt(0).toUpperCase() + platform.slice(1)} Session Setup`,
          steps: [
            '1. Open the platform in your browser and log in',
            '2. Open browser developer tools (F12)',
            '3. Extract cookies and session data',
            '4. Format as JSON and paste below'
          ],
          script: '// Platform-specific extraction script',
          note: 'Please refer to platform-specific documentation for detailed instructions.'
        };
    }
  };

  useEffect(() => {
    loadSessions();
    loadSessionStatus();
  }, []);

  const loadSessions = async () => {
    try {
      const response = await apiService.getUserSessions();
      setSessions(response || []);
    } catch (error) {
      console.error('Failed to load sessions:', error);
      toast.error('Failed to load sessions');
    }
  };

  const loadSessionStatus = async () => {
    try {
      const response = await apiService.getSessionStatus();
      setSessionStatus(response || {});
    } catch (error) {
      console.error('Failed to load session status:', error);
      toast.error('Failed to load session status');
    }
  };

  // Validation is now handled by the backend

  const handleUploadSession = async () => {
    console.log('🚀 Upload session button clicked');
    console.log('Platform:', selectedPlatform);
    console.log('Expires hours:', expiresHours);
    console.log('Session data length:', sessionDataText.length);
    
    if (!sessionDataText.trim()) {
      console.log('❌ No session data provided');
      toast.error('Please paste your session data');
      return;
    }

    setLoading(true);
    try {
      // Parse session data
      let sessionData: SessionData;
      try {
        sessionData = JSON.parse(sessionDataText);
        console.log('✅ JSON parsed successfully');
        console.log('Cookies count:', sessionData.cookies?.length || 0);
        console.log('Origins count:', sessionData.origins?.length || 0);
      } catch (error) {
        console.log('❌ JSON parse error:', error);
        toast.error('Invalid JSON format. Please check your session data.');
        return;
      }

      // For Facebook, merge manual cookies with session data
      if (selectedPlatform === 'facebook') {
        console.log('🔧 Merging manual cookies for Facebook');
        const manualCookieEntries = Object.entries(manualCookies).filter(([_, value]) => value.trim());
        
        if (manualCookieEntries.length > 0) {
          console.log('📝 Adding manual cookies:', manualCookieEntries.map(([key, _]) => key));
          
          // Add manual cookies to the session data
          if (!sessionData.cookies) {
            sessionData.cookies = [];
          }
          
          // Remove existing manual cookies if they exist
          const manualCookieNames = ['xs', 'fr', 'datr', 'sb', 'fb_dtsg', 'lsd'];
          sessionData.cookies = sessionData.cookies.filter(cookie => !manualCookieNames.includes(cookie.name));
          
          // Add new manual cookies
          manualCookieEntries.forEach(([name, value]) => {
            sessionData.cookies.push({
              name: name,
              value: value,
              domain: '.facebook.com',
              path: '/',
              secure: true,
              httpOnly: true,
              sameSite: 'None'
            });
          });
          
          console.log('✅ Manual cookies merged successfully');
        } else {
          console.log('⚠️ No manual cookies provided for Facebook');
        }
      }

      // Skip frontend validation - let backend handle it
      console.log('🔍 Skipping frontend validation (backend will validate)');
      console.log('✅ Proceeding with upload');

      // Upload session
      console.log('📤 Uploading session to backend...');
      const uploadData = {
        platform: selectedPlatform,
        session_data: sessionData,
        expires_hours: expiresHours
      };
      console.log('Upload payload:', uploadData);
      
      await apiService.uploadSession(uploadData);
      console.log('✅ Session uploaded successfully');

      toast.success(`${selectedPlatform} session ${isEditMode ? 'updated' : 'uploaded'} successfully!`);
      setSessionDataText('');
      setManualCookies({ xs: '', fr: '', datr: '', sb: '', fb_dtsg: '', lsd: '' });
      setIsEditMode(false);
      await loadSessions();
      await loadSessionStatus();
      
    } catch (error: any) {
      console.error('❌ Upload failed:', error);
      console.error('Error details:', {
        message: error.message,
        response: error.response,
        status: error.status,
        data: error.response?.data
      });
      const errorMessage = error.response?.data?.error || error.message || 'Failed to upload session';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteSession = async (platform: string) => {
    if (!window.confirm(`Are you sure you want to delete the ${platform} session?`)) {
      return;
    }

    try {
      await apiService.deleteSession(platform);
      toast.success(`${platform} session deleted successfully`);
      await loadSessions();
      await loadSessionStatus();
    } catch (error: any) {
      console.error('Delete failed:', error);
      toast.error('Failed to delete session');
    }
  };

  const handleEditSession = (session: any) => {
    // Set the form to edit mode
    setIsEditMode(true);
    setSelectedPlatform(session.platform);
    
    // Set session data text
    const sessionDataString = JSON.stringify(session.session_data, null, 2);
    setSessionDataText(sessionDataString);
    
    // Extract manual cookies from session data if they exist
    const cookies = session.session_data?.cookies || [];
    
    const extractedCookies = {
      xs: '',
      fr: '',
      datr: '',
      sb: '',
      fb_dtsg: '',
      lsd: ''
    };
    
    cookies.forEach((cookie: any) => {
      if (cookie.name in extractedCookies) {
        extractedCookies[cookie.name as keyof typeof extractedCookies] = cookie.value;
      }
    });
    
    setManualCookies(extractedCookies);
    
    // Switch to upload tab
    setActiveTab('upload');
    
    toast.success(`Editing ${session.platform} session. Update the data and click Update Session to save changes.`);
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
    setSessionDataText('');
    setManualCookies({ xs: '', fr: '', datr: '', sb: '', fb_dtsg: '', lsd: '' });
    setSelectedPlatform('facebook');
    toast.success('Edit mode cancelled');
  };


  const verifySession = async (platform: string) => {
    try {
      setLoading(true);
      // This would call a session verification endpoint
      const response = await apiService.verifySession(platform);
      
      if (response.valid) {
        toast.success(`${platform} session is valid and working!`);
      } else {
        toast.error(`${platform} session is invalid: ${response.error}`);
      }
    } catch (error: any) {
      console.error('Session verification failed:', error);
      toast.error(error.message || 'Session verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleTestSession = async () => {
    if (!testEmail.trim()) {
      toast.error('Please enter an email to test');
      return;
    }

    if (!sessionStatus[testPlatform]?.has_session) {
      toast.error(`No active session found for ${testPlatform}`);
      return;
    }

    setTestLoading(true);
    try {
      // This would call your session-based account finder
      const response = await apiService.findAccounts({
        parameterType: 2, // Email parameter type ID
        searchValue: testEmail
      });

      setTestResults({
        ...testResults,
        [testPlatform]: {
          email: testEmail,
          result: response,
          timestamp: new Date().toISOString()
        }
      });

      toast.success('Test completed! Check results below.');
      
    } catch (error: any) {
      console.error('Test failed:', error);
      const errorMessage = error.response?.data?.error || 'Test failed';
      toast.error(errorMessage);
    } finally {
      setTestLoading(false);
    }
  };

  const copyExampleSession = () => {
    const exampleSession = {
      "cookies": [
        {
          "name": "c_user",
          "value": "YOUR_USER_ID_HERE",
          "domain": ".facebook.com",
          "path": "/",
          "secure": true,
          "httpOnly": false,
          "sameSite": "Lax"
        },
        {
          "name": "xs",
          "value": "YOUR_SESSION_TOKEN_HERE",
          "domain": ".facebook.com",
          "path": "/",
          "secure": true,
          "httpOnly": true,
          "sameSite": "None"
        },
        {
          "name": "datr",
          "value": "YOUR_DATR_TOKEN_HERE",
          "domain": ".facebook.com",
          "path": "/",
          "secure": true,
          "httpOnly": true,
          "sameSite": "None"
        }
      ],
      "origins": [
        {
          "origin": "https://www.facebook.com",
          "localStorage": {},
          "sessionStorage": {}
        }
      ]
    };

    navigator.clipboard.writeText(JSON.stringify(exampleSession, null, 2));
    toast.success('Example session format copied to clipboard');
  };

  const getStatusBadge = (platform: string) => {
    const status = sessionStatus[platform];
    if (!status) return <Badge variant="secondary">Unknown</Badge>;

    if (status.has_session && !status.is_expired) {
      return <Badge variant="default" className="bg-green-500">Active</Badge>;
    } else if (status.has_session && status.is_expired) {
      return <Badge variant="destructive">Expired</Badge>;
    } else {
      return <Badge variant="secondary">No Session</Badge>;
    }
  };

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">Session Manager</h1>
          <p className="text-muted-foreground">
            Manage browser sessions for social media account finding
          </p>
        </div>
        <Button onClick={loadSessionStatus} variant="outline" size="sm">
          <RefreshCwIcon />
          <span className="ml-2">Refresh</span>
        </Button>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="upload">Upload Session</TabsTrigger>
          <TabsTrigger value="status">Session Status</TabsTrigger>
          <TabsTrigger value="test">Test Sessions</TabsTrigger>
          <TabsTrigger value="manage">Manage</TabsTrigger>
        </TabsList>

        <TabsContent value="upload" className="space-y-4">
          <Card>
            <CardHeader>
                          <CardTitle className="flex items-center gap-2">
              <UploadIcon />
              Upload Browser Session
            </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <Alert>
                <AlertCircleIcon />
                <AlertDescription>
                  Extract session data from your browser using Developer Tools. 
                  <Button 
                    variant="ghost" 
                    className="p-0 h-auto ml-1"
                    onClick={copyExampleSession}
                  >
                    Copy example format
                  </Button>
                </AlertDescription>
              </Alert>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="platform">Platform</Label>
                  <select
                    id="platform"
                    value={selectedPlatform}
                    onChange={(e) => setSelectedPlatform(e.target.value)}
                    className="w-full p-2 border rounded-md"
                  >
                    {platforms.map(platform => (
                      <option key={platform.value} value={platform.value}>
                        {platform.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <Label htmlFor="expires">Expires (hours)</Label>
                  <Input
                    id="expires"
                    type="number"
                    value={expiresHours}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setExpiresHours(parseInt(e.target.value))}
                    min="1"
                    max="168"
                  />
                </div>
              </div>

              {/* Platform-specific instructions */}
              {(() => {
                const instructions = getPlatformInstructions(selectedPlatform);
                return (
                  <Card className="border-blue-200 dark:border-blue-800 bg-blue-50 dark:bg-blue-900/20">
                    <CardHeader>
                      <CardTitle className="text-lg text-blue-800">
                        📋 {instructions.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                      <div>
                        <h4 className="font-semibold text-blue-700 dark:text-blue-300 mb-2">Steps:</h4>
                        <ol className="list-decimal list-inside space-y-1 text-sm text-blue-600 dark:text-blue-400">
                          {instructions.steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ol>
                      </div>
                      
                      {selectedPlatform === 'facebook' && (
                        <div>
                          <h4 className="font-semibold text-blue-700 dark:text-blue-300 mb-2">Browser Script:</h4>
                          <div className="bg-gray-900 text-green-400 p-3 rounded-md text-xs font-mono overflow-x-auto">
                            <pre>{instructions.script}</pre>
                          </div>
                          <Button
                            variant="outline"
                            size="sm"
                            className="mt-2"
                            onClick={() => {
                              navigator.clipboard.writeText(instructions.script);
                              toast.success('Script copied to clipboard!');
                            }}
                          >
                            📋 Copy Script
                          </Button>
                        </div>
                      )}
                      
                      <Alert className="border-blue-200 dark:border-blue-800 bg-blue-100 dark:bg-blue-900/30">
                        <AlertCircleIcon className="text-blue-600 dark:text-blue-400" />
                        <AlertDescription className="text-blue-700 dark:text-blue-300">
                          {instructions.note}
                        </AlertDescription>
                      </Alert>
                    </CardContent>
                  </Card>
                );
              })()}

              <div>
                <div className="flex items-center justify-between mb-2">
                  <Label htmlFor="sessionData">Session Data (JSON)</Label>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setShowSessionData(!showSessionData)}
                  >
                    {showSessionData ? <EyeOffIcon /> : <EyeIcon />}
                  </Button>
                </div>
                <Textarea
                  id="sessionData"
                  value={sessionDataText}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setSessionDataText(e.target.value)}
                  placeholder="Paste your browser session JSON here..."
                  rows={10}
                  className="font-mono text-sm"
                />
              </div>

              {/* Manual Cookie Input for Facebook */}
              {selectedPlatform === 'facebook' && (
                <Card className="border-orange-200 bg-orange-50">
                  <CardHeader>
                    <CardTitle className="text-lg text-orange-800">
                      🔧 Manual Cookie Input (Required for httpOnly cookies)
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <Alert className="border-orange-200 bg-orange-100">
                      <AlertCircleIcon className="text-orange-600" />
                      <AlertDescription className="text-orange-700">
                        Some Facebook cookies are httpOnly and cannot be extracted via JavaScript. 
                        You need to manually copy them from Developer Tools and paste them here.
                      </AlertDescription>
                    </Alert>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <Label htmlFor="xs_cookie">XS Cookie (Most Important)</Label>
                        <Input
                          id="xs_cookie"
                          placeholder="28%3AukqXB8kkXBZHuQ%3A2%3A1757341836..."
                          value={manualCookies.xs}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, xs: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                      <div>
                        <Label htmlFor="fr_cookie">FR Cookie</Label>
                        <Input
                          id="fr_cookie"
                          placeholder="171AcSN222ZEpNEmj.AWeq65CDHaxIZSiXRPudVIrsfGhePPuAP6hqu1mmZG0JTgEguHw.Bov5cL..AAA.0.0.Bov5cL.AWf22zfbDCnRJwNXB8N2hqW8ds8"
                          value={manualCookies.fr}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, fr: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                      <div>
                        <Label htmlFor="datr_cookie">DATR Cookie</Label>
                        <Input
                          id="datr_cookie"
                          placeholder="jOi-aO-B8qPbP3ZwxuER9s_j"
                          value={manualCookies.datr}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, datr: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                      <div>
                        <Label htmlFor="sb_cookie">SB Cookie</Label>
                        <Input
                          id="sb_cookie"
                          placeholder="OOq2aOCK6q9QRW__APPAJGHe"
                          value={manualCookies.sb}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, sb: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                      <div>
                        <Label htmlFor="fb_dtsg_cookie">FB DTSG Token (Critical)</Label>
                        <Input
                          id="fb_dtsg_cookie"
                          placeholder="NAfsSxQLXK4EtKPPfWwo0pOsVA01ctCw3NB_P3p4zv8s6CwwsIHhdIg:28:1757341836"
                          value={manualCookies.fb_dtsg}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, fb_dtsg: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                      <div>
                        <Label htmlFor="lsd_cookie">LSD Token (Critical)</Label>
                        <Input
                          id="lsd_cookie"
                          placeholder="SjSd_R3sdHolAS5IPavaBM"
                          value={manualCookies.lsd}
                          onChange={(e) => setManualCookies(prev => ({ ...prev, lsd: e.target.value }))}
                          className="font-mono text-xs"
                        />
                      </div>
                    </div>
                    
                    <div className="text-sm text-orange-600">
                      <strong>How to get these cookies and tokens:</strong>
                      <ol className="list-decimal list-inside mt-2 space-y-1">
                        <li>Open Facebook in your browser and make sure you're logged in</li>
                        <li>Open Developer Tools (F12)</li>
                        <li>Go to Application/Storage tab</li>
                        <li>Click on Cookies → https://www.facebook.com</li>
                        <li>Copy the values for xs, fr, datr, and sb cookies</li>
                        <li>For DTSG and LSD tokens:</li>
                        <li style={{marginLeft: '20px'}}>a. Go to Network tab in Developer Tools</li>
                        <li style={{marginLeft: '20px'}}>b. Make a search on Facebook (search for anything)</li>
                        <li style={{marginLeft: '20px'}}>c. Look for a GraphQL request to /api/graphql/</li>
                        <li style={{marginLeft: '20px'}}>d. In the request headers, find "fb_dtsg" and "x-fb-lsd"</li>
                        <li style={{marginLeft: '20px'}}>e. Copy these values (fb_dtsg goes in DTSG field, x-fb-lsd goes in LSD field)</li>
                        <li>Paste all values in the fields above</li>
                      </ol>
                    </div>
                  </CardContent>
                </Card>
              )}

              <div className="flex gap-2">
                <Button 
                  onClick={handleUploadSession} 
                  disabled={loading}
                  className="flex-1"
                >
                  {loading ? (
                    <>
                      <RefreshCwIcon />
                      <span className="ml-2">Uploading...</span>
                    </>
                  ) : (
                    <>
                      <UploadIcon />
                      <span className="ml-2">{isEditMode ? 'Update Session' : 'Upload Session'}</span>
                    </>
                  )}
                </Button>
                {isEditMode && (
                  <Button 
                    onClick={handleCancelEdit} 
                    disabled={loading}
                    variant="outline"
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="status" className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {platforms.map(platform => {
              const status = sessionStatus[platform.value];
              return (
                <Card key={platform.value}>
                  <CardHeader className="pb-3">
                    <div className="flex items-center justify-between">
                      <CardTitle className="text-lg">{platform.label}</CardTitle>
                      {getStatusBadge(platform.value)}
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-2">
                    {status ? (
                      <>
                        <div className="flex justify-between text-sm">
                          <span>Cost:</span>
                          <span>{status.cost} coins</span>
                        </div>
                        {status.has_session && (
                          <>
                            <div className="flex justify-between text-sm">
                              <span>Expires:</span>
                              <span className="text-xs">
                                {status.expires_at 
                                  ? new Date(status.expires_at).toLocaleDateString()
                                  : 'N/A'
                                }
                              </span>
                            </div>
                            <div className="flex justify-between text-sm">
                              <span>Last Used:</span>
                              <span className="text-xs">
                                {status.last_used 
                                  ? new Date(status.last_used).toLocaleDateString()
                                  : 'Never'
                                }
                              </span>
                            </div>
                          </>
                        )}
                        {status.has_session && (
                          <div className="pt-2">
                            <Button
                              variant="outline"
                              size="sm"
                              className="w-full"
                              onClick={() => verifySession(platform.value)}
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <RefreshCwIcon />
                                  <span className="ml-1">Verifying...</span>
                                </>
                              ) : (
                                <>
                                  <TestTubeIcon />
                                  <span className="ml-1">Verify Session</span>
                                </>
                              )}
                            </Button>
                          </div>
                        )}
                      </>
                    ) : (
                      <p className="text-sm text-muted-foreground">
                        Platform not configured
                      </p>
                    )}
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </TabsContent>

        <TabsContent value="test" className="space-y-4">
          <Card>
            <CardHeader>
                          <CardTitle className="flex items-center gap-2">
              <TestTubeIcon />
              Test Session-Based Account Finding
            </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label htmlFor="testPlatform">Platform</Label>
                  <select
                    id="testPlatform"
                    value={testPlatform}
                    onChange={(e) => setTestPlatform(e.target.value)}
                    className="w-full p-2 border rounded-md"
                  >
                    {platforms.map(platform => (
                      <option 
                        key={platform.value} 
                        value={platform.value}
                        disabled={!sessionStatus[platform.value]?.has_session}
                      >
                        {platform.label} {!sessionStatus[platform.value]?.has_session ? '(No Session)' : ''}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <Label htmlFor="testEmail">Email to Test</Label>
                  <Input
                    id="testEmail"
                    type="email"
                    value={testEmail}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTestEmail(e.target.value)}
                    placeholder="test@example.com"
                  />
                </div>
              </div>

              <Button 
                onClick={handleTestSession} 
                disabled={testLoading || !sessionStatus[testPlatform]?.has_session}
                className="w-full"
              >
                {testLoading ? (
                  <>
                    <RefreshCwIcon />
                    <span className="ml-2">Testing...</span>
                  </>
                ) : (
                  <>
                    <TestTubeIcon />
                    <span className="ml-2">Test Account Finding</span>
                  </>
                )}
              </Button>

              {testResults[testPlatform] && (
                <Card className="mt-4">
                  <CardHeader>
                    <CardTitle className="text-lg">Test Results</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Email:</span>
                        <span className="font-mono">{testResults[testPlatform].email}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Platform:</span>
                        <span>{testPlatform}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Result:</span>
                        <Badge variant={testResults[testPlatform].result?.status === 'completed' ? 'default' : 'destructive'}>
                          {testResults[testPlatform].result?.status || 'Unknown'}
                        </Badge>
                      </div>
                      <div className="flex justify-between">
                        <span>Timestamp:</span>
                        <span className="text-sm">
                          {new Date(testResults[testPlatform].timestamp).toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              )}
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="manage" className="space-y-4">
          <Card>
            <CardHeader>
                          <CardTitle className="flex items-center gap-2">
              <SettingsIcon />
              Manage Sessions
            </CardTitle>
            </CardHeader>
            <CardContent>
              {sessions.length === 0 ? (
                <p className="text-muted-foreground text-center py-8">
                  No sessions found. Upload a session to get started.
                </p>
              ) : (
                <div className="space-y-4">
                  {sessions.map(session => (
                    <div key={session.id} className="flex items-center justify-between p-4 border rounded-lg">
                      <div className="flex items-center space-x-4">
                        <div className={`w-3 h-3 rounded-full ${
                          session.is_expired ? 'bg-red-500' : 'bg-green-500'
                        }`} />
                        <div>
                          <h3 className="font-semibold">{session.platform_display_name}</h3>
                          <p className="text-sm text-muted-foreground">
                            Created: {new Date(session.created_at).toLocaleDateString()}
                          </p>
                          <p className="text-sm text-muted-foreground">
                            Expires: {new Date(session.expires_at).toLocaleDateString()}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        {session.is_expired ? (
                          <Badge variant="destructive">Expired</Badge>
                        ) : (
                          <Badge variant="default">Active</Badge>
                        )}
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={() => handleEditSession(session)}
                        >
                          <EditIcon />
                        </Button>
                        <Button
                          variant="destructive"
                          size="sm"
                          onClick={() => handleDeleteSession(session.platform)}
                        >
                          <Trash2Icon />
                        </Button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SessionManager;
